import { render } from "./Cursor.vue?vue&type=template&id=1bf904f4"
import script from "./Cursor.vue?vue&type=script&lang=js"
export * from "./Cursor.vue?vue&type=script&lang=js"

import "./Cursor.vue?vue&type=style&index=0&id=1bf904f4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__